import React, { memo } from 'react';
import cn from 'classnames';

var styles = {"bar":"stepped-progress-bar__bar_a6ejs","positive":"stepped-progress-bar__positive_a6ejs","attention":"stepped-progress-bar__attention_a6ejs","negative":"stepped-progress-bar__negative_a6ejs","link":"stepped-progress-bar__link_a6ejs","tertiary":"stepped-progress-bar__tertiary_a6ejs","secondary":"stepped-progress-bar__secondary_a6ejs","primary":"stepped-progress-bar__primary_a6ejs","accent":"stepped-progress-bar__accent_a6ejs"};
require('./index.css')

var StepBar = memo(function (_a) {
    var isDone = _a.isDone, _b = _a.view, view = _b === void 0 ? 'positive' : _b, classNameStep = _a.classNameStep;
    return (React.createElement("span", { "data-test-id": isDone ? 'on' : 'off', className: cn(styles.bar, isDone && styles[view], classNameStep) }));
});

export { StepBar };
